function WallVideo(wall, container, num) {

	this.wall = wall;
	this.container = container;
	this.container.data("layout-complete", 0);

	this.filename = "video" + num + ".webm";

	this.videoEl;
	this.videoWrapper = $('<div class="video-wrapper"></div>');
	this.videoWrapperInner = $('<div class="video-wrapper-inner"></div>');
	this._hasStream = false;

	// Create the video element
	this.videoEl = document.createElement('video');
	this.videoEl.setAttribute("loop", "");
	this.videoEl.setAttribute("autoplay", "");
	this.videoEl.setAttribute("class", "video-" + num);
	this.videoEl.src = "videos/" + this.filename;

	this.videoWrapperInner.append(this.videoEl);
	this.videoWrapper.append(this.videoWrapperInner);

	this.addToGrid();
}

WallVideo.prototype.addToGrid = function () {
	if (!this.wall.isInit) {
		this.container.append(this.videoWrapper).isotope('appended', this.videoWrapper);
	} else {
		this.container.isotope('remove', this.wall.wallVideos[0].videoWrapper).isotope('layout');

		this.container.one('layoutComplete', $.proxy(function (event, laidOutItems) {
			this.container.append(this.videoWrapper).isotope('appended', this.videoWrapper);
		}, this));


		var tween = TweenMax.fromTo(this.videoEl, 1, {
			opacity: 0,
			scaleX: 0,
			scaleY: 0
		}, {
			opacity: 1,
			scaleX: -1,
			scaleY: 1,
			ease: Back.easeOut.config(6),
			delay: numScreens / 2,
			onComplete: $.proxy(function () {
				console.log("anim complete");

				// $(this.videoEl).removeAttr('style');

				// we can now tell the wall to clean leftover videos
				this.wall.clean();

			}, this)
		});

	}

}

WallVideo.prototype.play = function () {
	if (this.hasStream()) {
		this.videoEl.play();
	}
}

WallVideo.prototype.pause = function () {
	if (this.hasStream()) {
		this.videoEl.pause();
	}
}

WallVideo.prototype.ended = function () {
	if (this.hasStream()) {
		this.isEnded = true;
	}
}

WallVideo.prototype.reset = function () {
	if (this.hasStream()) {
		this.isEnded = false;
		this.pause();
		this.videoEl.currentTime = 0;
	}
}

WallVideo.prototype.dispose = function () {
	this.videoEl.pause();
	this.videoEl.src = ""; // empty source
	this.videoEl.load();
	$(this.videoEl).remove();
	this.videoEl = null;
}

WallVideo.prototype.hasStream = function () {
	if (this._hasStream) {
		return true;
	} else if (this.videoEl.readyState === this.videoEl.HAVE_ENOUGH_DATA) {
		this._hasStream = true;
		return true;
	}
}

WallVideo.prototype.isPlaying = function () {
	if (this.hasStream()) {
		return !this.videoEl.paused;
	}
	return false;
}

// Expose App
window.WallVideo = WallVideo;